import React, { useEffect, useState } from 'react';
import CenterModal from '../../../../../layout/ReusableComponent/CenterModalWindow/CenterModalWindow';
import ButtonPill from '../../../../../layout/ReusableComponent/Buttons/button-pills';

/**
 * Reusable modal for reporting open-discussion content (topics, replies, clubs).
 * Parent passes async onSubmit(brief); on success the modal closes. On failure, rethrow to stay open.
 */
export function DiscussionReportModal({
  isOpen,
  onClose,
  title,
  description,
  eyebrow = 'Moderation',
  submitLabel = 'Submit report',
  onSubmit,
  maxLength = 2000,
}) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setText('');
      setBusy(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    if (!busy) onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    setBusy(true);
    try {
      await onSubmit(t);
      onClose();
    } catch {
      /* Parent shows error; keep modal open */
    } finally {
      setBusy(false);
    }
  };

  return (
    <CenterModal
      isOpen={isOpen}
      onClose={handleClose}
      width="min(520px, calc(100vw - 32px))"
      height="auto"
      contentStyle={{ height: 'auto' }}
      contentClassName="support-open-disc-tag-modal support-open-disc-report-modal"
    >
      <div className="support-open-disc-tag-modal-body support-open-disc-report-modal-body">
        <header className="support-open-disc-tag-modal-head">
          <p className="support-open-disc-tag-modal-eyebrow">{eyebrow}</p>
          <h3 id="disc-report-title" className="support-open-disc-tag-modal-title">
            {title}
          </h3>
          {description ? (
            <p id="disc-report-desc" className="support-open-disc-tag-modal-lead">
              {description}
            </p>
          ) : null}
        </header>
        <form
          className="support-open-disc-report-form"
          onSubmit={handleSubmit}
          aria-labelledby="disc-report-title"
          aria-describedby={description ? 'disc-report-desc' : undefined}
        >
          <label className="support-open-disc-tag-modal-field support-open-disc-report-modal-field">
            <span>What should moderators know?</span>
            <textarea
              className="support-open-disc-report-textarea"
              value={text}
              onChange={(ev) => setText(ev.target.value.slice(0, maxLength))}
              rows={5}
              maxLength={maxLength}
              placeholder="Give a short, clear summary…"
              disabled={busy}
              autoFocus={isOpen}
            />
            <span className="support-open-disc-report-counter" aria-live="polite">
              {text.length}/{maxLength}
            </span>
          </label>
          <footer className="support-open-disc-tag-modal-actions support-open-disc-report-modal-actions">
            <ButtonPill
              type="button"
              variant="outline"
              shape="pill"
              size="sm"
              color="brand"
              className="support-open-disc-tag-modal-cancel"
              onClick={handleClose}
              disabled={busy}
            >
              Cancel
            </ButtonPill>
            <ButtonPill
              type="submit"
              variant="solid"
              shape="pill"
              size="sm"
              color="warning"
              disabled={busy || !text.trim()}
            >
              {busy ? 'Sending…' : submitLabel}
            </ButtonPill>
          </footer>
        </form>
      </div>
    </CenterModal>
  );
}
